<template>
  <div>
    <ActionsMenu
      class="actions-menu"
      :actions="actions"
      :options="{
        theme: 'light tooltip-standard-size'
      }"
      @edit-tag="toggleTagModal"
      @delete-tag="handleDeleteClicked"
    />
    <TagModal
      v-if="showTagModal"
      :isNew="false"
      :tag="tag"
      @hide-modal="toggleTagModal"
      @save-success="handleSaveSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { EventBus } from "@/lib/event_bus.js";

import { Tag } from "@/typings/tag";
import store from "@/vuex/store";
import TagModal from "./TagModal.vue";

const props = defineProps<{
  tag: Tag;
}>();

const actions = [
  {
    label: "Edit",
    icon: "fas fa-pencil-alt",
    eventName: "edit-tag",
    className: "menu-item"
  },
  {
    label: "Delete",
    icon: "fas fa-trash-alt",
    eventName: "delete-tag",
    className: "menu-item"
  }
];

const showTagModal = ref(false);

const confirmDelete = async (payload = {}) => {
  await store.dispatch("confirmDelete", payload);
};

const handleDeleteClicked = async (tag) => {
  confirmDelete({
    message:
      "This action will remove the tag from all associated records. Are you sure you want to remove this tag?",
    title: "Confirm Delete Tag"
  }).then(() => {
    removeTag(tag);
  });
};

const removeTag = async (tag) => {
  try {
    const response = await fetch(`/v3/tags/${props.tag.id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" }
    });

    if (!response.ok) throw new Error("Failed to remove tag");

    const data = await response.json();
    EventBus.$emit("remove-tag-filter", data);
    EventBus.$emit("refresh-datatable");
  } catch (error) {
    console.error("Error removing tag:", error);
  }
};

const toggleTagModal = () => {
  showTagModal.value = !showTagModal.value;
};

const handleSaveSuccess = (tag) => {
  toggleTagModal();
  EventBus.$emit("remove-tag-filter", tag);
  EventBus.$emit("add-tag-filter", tag);
  EventBus.$emit("refresh-datatable");
};
</script>

<style lang="scss"></style>
